import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, { id: "subscribe" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.showSnackbar,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showSnackbar) = $event)),
        color: "surface",
        style: { bottom: `20px` },
        absolute: "",
        bottom: "",
        timeout: 5000
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.snackbar = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "primary",
                size: "large",
                class: "mt-n1 mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.snackbarIcn), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.snackbarText) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_container, {
        class: "py-6 px-4 ma-0",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "text-right"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("span", null, [
                    _createTextVNode("A "),
                    _createElementVNode("a", {
                      href: "https://missionsquad.ai",
                      target: "_blank"
                    }, "Mission Squad"),
                    _createTextVNode(" agent.")
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}